import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { FORM_MODE } from 'shared/enums';
import { RootState } from 'store';
const Header: React.FC = () => {
  const { mode } = useSelector(
    (state: RootState) => state.selectedMailingRuleModeNavigation,
  );
  return (
    <Grid item xs={12}>
      {mode === FORM_MODE.create && (
        <Typography
          data-cy="page-title-create-mailing-rule__label--title"
          paragraph
          variant="h4"
        >
          Cadastro de Régua de Mailing
        </Typography>
      )}
      {mode === FORM_MODE.edit && (
        <Typography
          data-cy="page-title-edit-mailing-rule__label--title"
          paragraph
          variant="h4"
        >
          Edição de Régua de Mailing
        </Typography>
      )}
      {mode === FORM_MODE.view && (
        <Typography
          data-cy="page-title-show-mailing-rule__label--title"
          paragraph
          variant="h4"
        >
          Visualização de Régua de Mailing
        </Typography>
      )}
    </Grid>
  );
};

export default Header;
